import React from 'react';
import { Row, Col, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { getNameWhiteLabel } from '../../../../../services/utils';

const CreditAccountInfo = ({ domain, phoneGeneral, onPhoneChange, errors }) => {
  const { t } = useTranslation();

  return (
    <Row type="flex" align="top" justify="start" className="content-row">
      <Col className="card" xs={24} sm={24} md={24} lg={24} xl={24}>
        <div className="ant-collapse-sub-header">
          {t('Information for direct current account payments with') +
            ' ' +
            getNameWhiteLabel(domain)}
        </div>
        <p>
          {t(
            'Once the payment has been made using this method, your media manager will be able to approve the campaign.'
          )}
        </p>
      </Col>
      <Col xs={8}>
        <p className="title-form">{t('Telephone contact')}</p>
        <Form.Item
          validateStatus={!!errors['phone_general'] && 'error'}
          help={errors['phone_general']}
        >
          <Input
            placeholder={t('Telephone contact')}
            autoComplete="tel"
            onChange={e => onPhoneChange(e.target.value)}
            value={phoneGeneral}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default CreditAccountInfo;
